/* eslint-disable abcsize/abcsize */
import {
  CACTUS_100,
  CHARCOAL_100,
  MOSS_100,
  OwnUpBody,
  OwnUpGridItem,
  OwnUpGridWrapper,
  OwnUpSmallBody,
  OwnUpSmallHeadlineMedium,
  PropsWithTheme,
  WALDEN_100
} from '@rategravity/own-up-component-library';
import { Link as GatsbyLink } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import {
  AffordabilityCalculator,
  DownPaymentCalculator,
  MonthlyPaymentCalculator,
  RentOrBuyCalculator,
  ABComparisonCalculator
} from '../../calculators';
import PortableText from '../../portable-text';
import CTAButtons1 from '../ctaButton1';
import InstagramVideoEmbed from '../instagram-video-embed';

export const Headline = styled(OwnUpSmallHeadlineMedium)`
  padding-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(7)}px;
`;

export const Link = styled(GatsbyLink)`
  color: ${({ theme }: PropsWithTheme<{}>) => theme.underlineLinkColors.linkFontColor};
  text-decoration: none;
`;

export const MetadataWrapper = styled.div`
  padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(2)}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(3)}px`};
  }
`;
export const MetadataInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(3)}px`};

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    flex-direction: column;
    align-items: start;
    gap: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(1)}px`};
  }
`;

export const CategoriesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(1)}px`};
`;

export const DateWrapper = styled.div`
  display: 'inline';
`;

export const ImageWrapper = styled(OwnUpGridWrapper)`
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('sm')} {
    margin: 0;
  }
  padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(5)}px`};
`;

export const BlogPostWrapper = styled(OwnUpGridItem)`
  > * {
    &:first-child {
      padding-top: 0px !important;
      margin-top: 0px;
    }
  }
  margin-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(5)}px`};
  margin-bottom: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(15)}px`};
  p {
    margin: 0;
    padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(0)}px`};
    &:not(:has(strong.highlight)) {
      padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(1)}px`};
    }
  }
  .widget-container {
    margin-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(5)}px`};
    p {
      &:not(:has(strong.highlight)) {
        padding-top: 0;
      }
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(5)}px`};
    margin: 0;
  }
  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(1)}px`};
  }
  p > img {
    width: 100%;
  }
  p strong.highlight {
    display: inline-block;
    padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(3)}px`};
  }
  p:not(:has(strong.highlight)) + p:not(:has(strong.highlight)) {
    padding-top: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(3)}px`};
  }
  li {
    padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(0.25, 5)};
    text-indent: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(-3)}px`};
  }
  li::before {
    content: '•';
    color: ${CACTUS_100};
    padding-right: ${({ theme }: PropsWithTheme<{}>) => `${theme.spacing(2)}px`};
  }
`;

export const AuthorWrapper = styled.div`
  display: flex;
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const TooltipContent = styled.span.attrs((props: { visible: boolean }) => props)`
  visibility: hidden;
  width: 328px;
  background-color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 16px;
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  border: 1px solid ${MOSS_100};

  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    left: 100%;
  }

  ${(props) =>
    props.visible &&
    `
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  `}
`;

export const TooltipContentTopWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TooltipContentBottomWrapper = styled.div``;

export const TooltipAuthorAvatar = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 16px;
`;

export const TooltipNameDesWrapper = styled.div``;

export const TooltipAuthorName = styled(OwnUpSmallHeadlineMedium)`
  margin: 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  color: ${CHARCOAL_100};
  text-decoration: underline;
`;

export const TooltipAuthorDesignation = styled(OwnUpSmallBody)`
  margin: 0;
  color: ${WALDEN_100};
`;

export const TooltipAuthorDescription = styled(OwnUpBody)`
  margin: 16px 0px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  line-clamp: 6;

  > :first-child {
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.14px;
  }
`;

export const TooltipText = styled.span`
  display: inline-block;
  cursor: pointer;

  &:hover + ${TooltipContent} {
    visibility: visible;
    opacity: 1;
  }
`;

export const CategoryGuidesContainer = styled.nav`
  li:not(:last-child)::after {
    content: '|';
    margin: 0 0.5rem;
    color: ${WALDEN_100};
    align-items: end;
  }

  a {
    text-decoration: none;
    transition: color 0.2s;
  }
`;

export const CategoryGuidesWrapper = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const CategoryGuidesItem = styled.li`
  display: flex;
  align-items: end;
`;

export const calculateBodyWordsCount = (blocks: Record<string, any>[]): number => {
  let wordsCount = 0;
  const whitespaceRegex = /\s+/;
  for (const block of blocks) {
    if (block._type === 'block') {
      for (const child of block.children) {
        const { text } = child;
        if (text) {
          wordsCount += text.split(whitespaceRegex).length;
        }
      }
    }
  }

  return wordsCount;
};

const enum AdminCalculatorTitles {
  Affordability = 'affordability',
  DownPayment = 'down-payment',
  MonthlyPayment = 'monthly-payment',
  RentOrBuy = 'rent-or-buy',
  ABComparison = 'ab-comparison'
}
const calculatorTitleToComponent = {
  [AdminCalculatorTitles.Affordability]: <AffordabilityCalculator />,
  [AdminCalculatorTitles.DownPayment]: <DownPaymentCalculator />,
  [AdminCalculatorTitles.MonthlyPayment]: <MonthlyPaymentCalculator />,
  [AdminCalculatorTitles.RentOrBuy]: <RentOrBuyCalculator />,
  [AdminCalculatorTitles.ABComparison]: <ABComparisonCalculator />
};

export const addInteractiveBlocksToArticle = (
  body: Record<string, any>[],
  href: string,
  wordsCount: number
) => {
  const blocks: Record<string, any>[] = [];
  let currentBlock: Record<string, any>[] = [];
  let h2Count = 0;

  const flushCurrentBlock = () => {
    if (currentBlock.length) {
      blocks.push({ comp: <PortableText href={href} blocks={currentBlock} /> });
      currentBlock = [];
    }
  };

  const addComponentToBlocks = (component: React.JSX.Element) => {
    flushCurrentBlock();
    blocks.push({ comp: component });
  };

  const handleH2BlockIncrement = () => {
    if (wordsCount > 500 && ++h2Count === 2) {
      addComponentToBlocks(<CTAButtons1 />);
    }
  };

  for (const block of body) {
    const { _type, style, url, calculator } = block;

    if (_type === 'instagramVideoEmbed') {
      addComponentToBlocks(<InstagramVideoEmbed url={url} />);
    } else if (_type === 'calculatorWidget') {
      addComponentToBlocks(calculatorTitleToComponent[calculator as AdminCalculatorTitles]);
    } else {
      if (style === 'h2') {
        handleH2BlockIncrement();
      }
      currentBlock.push(block);
    }
  }

  flushCurrentBlock();
  return blocks;
};
